import axios from '@/extensions/axios'

const actions = {
  create ({ commit, state, rootState }, newGroup = void 0) {
    let group = newGroup || state.newGroup
    return axios.post('sites/' + rootState.site.active.id + '/page-groups', group)
      .then(({ data }) => {
        commit('ADD', data)
        return data
      })
  },

  save ({ commit, state }, newGroup = void 0) {
    let group = newGroup || state.newGroup
    return axios.put('page-groups/' + group.id, group)
      .then(({ data }) => {
        commit('ADD', data)
        return data
      })
  },

  remove ({ commit }, key) {
    return axios.delete('page-groups/' + key)
      .then(() => {
        commit('REMOVE', key)
      })
  },

  get ({ commit, rootState }) {
    if (rootState.site.active.id) {
      return axios.get('sites/' + rootState.site.active.id + '/page-groups')
        .then(({ data }) => {
          commit('SET', data)
          return data
        })
    }
  },

  getById ({ commit }, id) {
    return axios.get('page-groups/' + id)
      .then(({ data }) => {
        commit('ADD', data)
        return data
      })
  }
}

export default actions
